module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jJe6O"))).then(() => parcelRequire('37nVf'));